import React, { Component } from "react";

import axios from "axios";

import schema from "./schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ErrorX, store } from "static";
import { DATA_LINK } from "connectors";

class SysDisclaimer extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      disclaimerDoc: undefined,
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this._getDisclaimer();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(SysDisclaimer.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  Disclaimer = {
    _onSubmit: async (data) => {
      let disclaimerLink = DATA_LINK.GetDisclaimer;
      let disclaimerUrl = DOMAIN + disclaimerLink;

      let disclaimerPayloadOut = {
        data: {
          ...data.disclaimerDoc,
        },
        JWT: store.user.JWT,
      };

      try {
        console.log(disclaimerLink, disclaimerPayloadOut);

        store.isLoading(true);
        let res = await axios.post(disclaimerUrl, disclaimerPayloadOut);
        store.isLoading(false);

        console.log(disclaimerLink, res.data);

        if (res.data.Success) {
          this.Disclaimer.onSuccess();
        } else {
          this.Disclaimer.onFail("System message update fails.");
        }
      } catch (e) {
        this.Disclaimer.onFail(ErrorX.Handle(e));
      }
    },

    onSuccess: () => {
      store.Alert("System message updated successfully", "success");
      this._getDisclaimer();
    },

    onFail: (msg) => {
      store.isLoading(false);
      store.Alert(msg, "error");
    },
  };

  _getDisclaimer = async () => {
    let link = DATA_LINK.GetDisclaimer;
    let url = DOMAIN + link;

    let payloadOut = {
      JWT: store.user.JWT,
    };

    try {
      console.log(link, payloadOut);

      store.isLoading(true);
      let res = await axios.post(url, payloadOut);
      store.isLoading(false);

      console.log(link, res.data);

      let { Success, payload } = res.data;
      let disclaimerDoc = {
        disclaimerDoc: payload,
      };

      if (Success) {
        this.setState({
          disclaimerDoc: disclaimerDoc,
        });
      } else {
        store.Alert(payload, "error");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderForm() {
    let { disclaimerDoc } = this.state;
    if (disclaimerDoc === undefined) return;

    let defaultValue = {
      ...disclaimerDoc,
    };
    return <Formizo height="100%" schema={schema.disclaimer} buttons={["Revert", "Submit"]} onSubmit={this.Disclaimer._onSubmit} defaultValue={defaultValue} />;
  }

  render() {
    return <VStack height="100%">{this.renderForm()}</VStack>;
  }
}

export default SysDisclaimer;
